<ul class="{{ 'ul-filter-' + filterGroup.presentation }}">
    @for (filter of filterGroup.filters; track trackByFilter(i, filter); let i = $index) {
    <li class="{{ 'li-filter-' + filterGroup.presentation }}">
        @if (filter.facetIsCrawlable) {

        <h-grid-filters-checkbox-crawlable
            class="filter-item-wrapper"
            [class.selected]="filter.selected"
            [filter]="filter"
            [filterGroup]="filterGroup"
            [isExpanded]="isExpanded"
            [dataTestId]="filterGroup.facetUrlParameterName + '_' + i">
            <ng-container *ngTemplateOutlet="checkboxFilterSpan"> </ng-container>
        </h-grid-filters-checkbox-crawlable>

        } @else {

        <button
            type="button"
            [attr.role]="'checkbox'"
            [attr.aria-checked]="filter.selected"
            class="filter-item-wrapper"
            [class.selected]="filter.selected"
            [id]="filter | gridFilterIdSetter : filterGroup"
            (click)="selectFilter(filter, $event)"
            [class.border]="filterGroup.presentation === 'grid'"
            [class.to-be-focused-when-opened]="i === 0"
            [class.selected]="filter.selected">
            <ng-container *ngTemplateOutlet="checkboxFilterSpan"></ng-container>
        </button>

        }

        <ng-template #checkboxFilterSpan>
            <h-grid-checkbox
                [filterGroup]="filterGroup"
                [filter]="filter"
                [filterId]="filter | gridFilterIdSetter : filterGroup">
            </h-grid-checkbox>
        </ng-template>
    </li>
    }
</ul>
